import { Globe, Check } from "lucide-react";
import { useTranslation } from "react-i18next";
import { setLocale, type Locale } from "@/lib/i18n";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

type Props = {
  /** Style variant. "light" for dark backgrounds (auth NavBar), "dark" for light backgrounds (marketing nav). */
  variant?: "light" | "dark";
  /** Compact hides the current-locale label text. */
  compact?: boolean;
};

export function LanguageSwitcher({ variant = "dark", compact = false }: Props) {
  const { i18n, t } = useTranslation();
  const current = (i18n.language?.startsWith("sv") ? "sv" : "en") as Locale;

  const trigger =
    variant === "light"
      ? "flex items-center gap-1.5 px-2 py-1.5 rounded-md text-xs font-medium text-primary-foreground/80 hover:text-primary-foreground hover:bg-primary-foreground/10 transition-colors"
      : "flex items-center gap-1.5 px-2 py-1.5 rounded-md text-xs font-medium text-foreground/70 hover:text-foreground hover:bg-muted transition-colors";

  return (
    <DropdownMenu>
      <DropdownMenuTrigger
        aria-label={t("common.language")}
        className={trigger}
      >
        <Globe className="size-4" />
        {!compact && <span className="uppercase">{current}</span>}
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="min-w-[10rem]">
        <DropdownMenuItem onClick={() => setLocale("en")} className="gap-2">
          <Check className={`size-3.5 ${current === "en" ? "opacity-100" : "opacity-0"}`} />
          {t("common.english")}
        </DropdownMenuItem>
        <DropdownMenuItem onClick={() => setLocale("sv")} className="gap-2">
          <Check className={`size-3.5 ${current === "sv" ? "opacity-100" : "opacity-0"}`} />
          {t("common.swedish")}
        </DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
